import { readContract, writeContractAndWait } from "../viem";
import MafiaSwapRouterAbi from "../../abis/BNBSwapRouter.json";
import config from "../../config/config";
import { SwapToken } from "../../types/Contract/SwapToken";

const address = config.swapRouter;
const abi = MafiaSwapRouterAbi;

export const getSwapTokens = async () => {
  const swapTokenInfo: [SwapToken[], number[]] = await readContract({
    address,
    abi,
    functionName: "getSwapTokens",
  });

  return swapTokenInfo;
};

export const getTokenPrice = async (tokenAddress: string) => {
  const tokenPrice = await readContract({
    address,
    abi,
    functionName: "getTokenPrice",
    args: [tokenAddress],
  });
  return tokenPrice;
};

export const swap = async (
  tokenFrom: string,
  tokenTo: string,
  amount: string,
  receiver: string,
  account: string
) => {
  const swap = await writeContractAndWait({
    address,
    abi,
    functionName: "swap",
    args: [tokenFrom, tokenTo, amount, receiver],
    account,
  });
  return swap;
};
